import _ from "lodash";
import moment from "moment";
import React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../components";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { Utility } from "../../../utils";

interface OwnProps {
    api: Api;
    isFullPage?: boolean;
    isLoggedIn: boolean;
    isPreview?: boolean;
    resume: M.CareerCenter.Resume;
    onTitleClick?: (resume: M.CareerCenter.Resume) => void;
    onDownloadFail?: (errors: string[]) => void;
    routePath?: string;
    showExpires?: boolean;
}

interface OwnState {
    loadingCV: boolean;
}

export class ResumeDetailsPartial extends React.Component<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            loadingCV: false,
        };
    }

    public render() {
        const resume = this.props.resume;
        const isMemberDisplay = resume.postedBy.isMember
            ? <li><strong><img className="asrs-eye" src={`${process.env.PUBLIC_URL}/content/images/asrs-eye.svg`} /> ASRS Member</strong></li>
            : null;
        const location = resume.postedBy.contacts.length
            ? ` – ${M.Generic.AddressHelper.displayCityStateInline(resume.postedBy.contacts[0], "name", false)}`
            : null;

        let expiresDisplay = null;
        if (this.props.showExpires && resume.expiresOn) {
            const expiresOn = Utility.utcToLocal(resume.expiresOn);
            expiresDisplay = new Date() > expiresOn
                ? <li><strong>Expired {moment(expiresOn).format("MMM D, YYYY")}</strong></li>
                : <li>Expires {moment(expiresOn).format("MMM D, YYYY")}</li>;
        }

        const title = this.props.isPreview && this.props.isLoggedIn
            ? <a href="#" onClick={(e) => this.handleTitleClick(e)}>{resume.title}{location}</a>
            : resume.title + location;

        let educations = <p>None listed</p>;
        let experiences = <p>None listed</p>;
        let relPrefs = <p>None listed</p>;

        if (resume.educations.length) {
            educations = <ul>
                {resume.educations.map((e, i) => (
                    <li key={i}>
                        {e.type}: {e.organization}, {e.completedOn ? moment(Utility.fromApiDate(e.completedOn)).format("MMM YYYY") : "Incomplete"}
                    </li>
                ))}
            </ul>;
        }

        if (resume.experiences.length) {
            experiences = <ul>
                {resume.experiences.map((e, i) => {
                    let pos: string | undefined = `${e.position} at ${e.organization}`;
                    if (!e.position)
                        pos = e.organization;
                    else if (!e.organization)
                        pos = e.position;
                    else if (!e.position && !e.organization)
                        return null;
                    return <li key={i}>{pos}</li>;
                })}
            </ul>;
        }

        if (resume.relocationPrefs.length) {
            relPrefs = <ul>
                {resume.relocationPrefs.map((r, i) => (
                    <li key={i}>
                        {M.Generic.AddressHelper.displayInline(r.location, "iso3")}
                    </li>
                ))}
            </ul>;
        }

        const latestEducation = _.maxBy(resume.educations, (e) => e.completedOn);
        const latestEdDisplay = latestEducation !== undefined
            ? <li>{latestEducation.type}: {latestEducation.organization}</li>
            : null;

        const downloadBtn = this.state.loadingCV
            ? <BS.Button bsStyle="primary">
                <Comp.Generic.Icon icon="spin fa-spinner" /> Downloading&hellip;
            </BS.Button>
            : <BS.Button bsStyle="primary" onClick={async () => await this.handleDownloadClick()}>
                <Comp.Generic.Icon icon="download" /> Download CV/Resume
            </BS.Button>;

        const cvDownload = resume.cvMedia
            ? downloadBtn
            : null;

        const userEmail = resume.postedBy.emails.length
            ? resume.postedBy.emails[0].address
            : resume.postedBy.username;

        const details = this.props.isPreview || !this.props.isLoggedIn
            ? null
            : <div className="jobs-description">
                <dl>
                    <dt>{M.Member.MemberHelper.fullName(resume.postedBy, true)}</dt>
                    <dd><a href={"mailto:" + userEmail}>{userEmail}</a></dd>

                    <dt>Cover Letter</dt>
                    <dd dangerouslySetInnerHTML={{ __html: resume.coverLetter || "Not available" }} />

                    <dt>Education &amp; Training</dt>
                    <dd>{educations}</dd>

                    <dt>Experience</dt>
                    <dd>{experiences}</dd>

                    <dt>Relocation Preference(s)</dt>
                    <dd>{relPrefs}</dd>
                </dl>

                {cvDownload}
            </div>;

        return <Comp.Generic.WrapperLess>
            <h3 className="jobs-title">{title}</h3>
            <ul className="jobs-summary">
                <li>Posted {moment(Utility.fromApiDate(resume.postedOn)).format("MMM D, YYYY")}</li>
                {expiresDisplay}
                {isMemberDisplay}
                {latestEdDisplay}
            </ul>

            {details}

        </Comp.Generic.WrapperLess>;
    }

    private handleTitleClick(e: React.MouseEvent<HTMLAnchorElement>) {
        if (this.props.onTitleClick)
            this.props.onTitleClick(this.props.resume);

        e.preventDefault();
        return false;
    }

    private async handleDownloadClick() {
        if (!this.props.resume.cvMedia)
            return;

        this.toggleLoadingCV(true);

        const qp = { queryParams: { guid: this.props.resume.cvMedia.guid }};
        const result = await this.props.api.get<M.Upload.Media>(Api.endpoints.media.media, qp);

        this.toggleLoadingCV(false);

        if (result.isSuccess && result.data && !result.data.url) {
            result.isSuccess = false;
            result.errors.push("CV has no download URL");
        }

        if (result.isSuccess && result.data) {
            const link = document.createElement("a");
            link.href = result.data.url || "/";
            document.body.appendChild(link);
            link.click();
            setTimeout(() => link.remove(), 250);
        }
        else {
            if (this.props.onDownloadFail)
                this.props.onDownloadFail(M.Result.Result.errorsOrMessage(result));
        }
    }

    private toggleLoadingCV(loadingCV: boolean) {
        this.setState({ ...this.state, loadingCV });
    }
}



// WEBPACK FOOTER //
// ./src/containers/careerCenter/resumeDetails/ResumeDetailsPartial.tsx